// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Editor-authored User Guide tab fields. Frontend-only; not written by any backend process.
 * @export
 * @interface DTADocumentContentUserGuide
 */
export interface DTADocumentContentUserGuide {
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentUserGuide
     */
    form_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentUserGuide
     */
    sdtm_library?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentUserGuide
     */
    sdtm_release_date?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentUserGuide
     */
    type?: string;
}

/**
 * Check if a given object implements the DTADocumentContentUserGuide interface.
 */
export function instanceOfDTADocumentContentUserGuide(value: object): value is DTADocumentContentUserGuide {
    return true;
}

export function DTADocumentContentUserGuideFromJSON(json: any): DTADocumentContentUserGuide {
    return DTADocumentContentUserGuideFromJSONTyped(json, false);
}

export function DTADocumentContentUserGuideFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADocumentContentUserGuide {
    if (json == null) {
        return json;
    }
    return {
        
        'form_id': json['form_id'] == null ? undefined : json['form_id'],
        'sdtm_library': json['sdtm_library'] == null ? undefined : json['sdtm_library'],
        'sdtm_release_date': json['sdtm_release_date'] == null ? undefined : json['sdtm_release_date'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function DTADocumentContentUserGuideToJSON(json: any): DTADocumentContentUserGuide {
    return DTADocumentContentUserGuideToJSONTyped(json, false);
}

export function DTADocumentContentUserGuideToJSONTyped(value?: DTADocumentContentUserGuide | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'form_id': value['form_id'],
        'sdtm_library': value['sdtm_library'],
        'sdtm_release_date': value['sdtm_release_date'],
        'type': value['type'],
    };
}
